export function getAllMonths(
  options: {
    locale?: string;
    format?: Intl.DateTimeFormatOptions['month'];
  } = {}
): Array<string> {
  const months = [...Array(12).keys()].map((key) =>
    new Date(0, key).toLocaleString(options.locale || 'en', {
      month: options.format || 'long',
    })
  );
  return months;
}

export function isSameDay(date1: Date, date2: Date): Boolean {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
}

export function removeTime(date: Date): Date {
  return new Date(date.toISOString().slice(0, 10));
}
